import React from 'react'

const TableHead = (props) => {
    return (
        <thead className="ShippingCarrierRuleTableHead TableHead">
        <tr className="RuleHeadTable">
            <th className="slug">Slug</th>
            <th className="shipping-carrier">Shipping Carrier</th>
            <th className="original-carrier">Original Carrier</th>
            <th className="shipping-box-type">Shipping Box Type</th>
            <th className="box-name">Box name</th>
            <th className="original-carrier-status">Original Carrier Status</th>
            <th className="label-generation-status">Label Generation Status</th>
            <th className="update-at">Update at</th>
            <th className="Action">Action</th>
        </tr>
        </thead>
    )
}

export default TableHead
